module.exports = __webpack_public_path__ + "img/thumbnail-iwt-02.b6aee07c.webp";